import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiStringFormat',
})
export class StringFormatPipe implements PipeTransform {
  transform(value: any, ...args: any[]): string {
    // eslint-disable-next-line prefer-rest-params
    return tiStringsFormat.apply(tiStringsFormat, arguments);
  }
}

export function tiStringsFormat(value: string, ...args: any[]): string {
  return value ? value.replace(/{(\d+)}/g, (m, i) => String(args[i] ?? '')) : value;
}

export function tiCommaSeparator(value): string {
  return isNaN(+value) ? value : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
